import React, { useContext } from "react";
// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import {Formik, Form, Field} from 'formik';
import {Select} from "formik-material-ui";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import { UserContext } from "../../Models/UserContext";

import fieldData from "../NewConnection/FormModel/fieldData";
import userProfileFormModel from "./FormModel/userProfileFormModel";

import connectionFormStyle from "../../assets/jss/material-dashboard-react/views/connectionFormStyle";
import avatar from "assets/img/faces/ashfaque.jpg";

const state = fieldData.state;
const useStyles = makeStyles(connectionFormStyle);

export default function UserProfile() {
    const user = useContext(UserContext);
    const {formId, formField} = userProfileFormModel;
    const [fullName, setFullName] = React.useState(user.data[formField.first_name.name] + " " + user.data[formField.last_name.name]);
    const [aboutMe, setAboutMe] = React.useState(user.data[formField.about_me.name]);
    const classes = useStyles();

    function handleSubmit(values, actions) {
      setFullName(values.first_name + " " + values.last_name);
      setAboutMe(values.about_me);
      user.setData(values);
      actions.setSubmitting(false);
    }

    return (
        <div>
            <Formik
                initialValues={user.data}
                onSubmit={handleSubmit}
            >
                {({isSubmitting}) => (
                    <Form id={formId}>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={8}>
                                <Card>
                                    <CardHeader color="primary">
                                        <h4 className={classes.cardTitleWhite}>Edit Profile</h4>
                                        <p className={classes.cardCategoryWhite}>Complete your profile</p>
                                    </CardHeader>
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={5}>
                                                <Field
                                                    component={CustomInput}
                                                    labelText={formField.company_name.label}
                                                    name={formField.company_name.name}
                                                    id={formField.company_name.name}
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={3}>
                                                <Field
                                                    component={CustomInput}
                                                    labelText={formField.dealer_code.label}
                                                    name={formField.dealer_code.name}
                                                    id={formField.dealer_code.name}
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={4}>
                                                <Field
                                                    component={CustomInput}
                                                    labelText={formField.email_address.label}
                                                    name={formField.email_address.name}
                                                    id={formField.email_address.name}
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <Field
                                                    component={CustomInput}
                                                    labelText={formField.first_name.label}
                                                    name={formField.first_name.name}
                                                    id={formField.first_name.name}
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <Field
                                                    component={CustomInput}
                                                    labelText={formField.last_name.label}
                                                    name={formField.last_name.name}
                                                    id={formField.last_name.name}
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={4}>
                                                <Field
                                                    component={CustomInput}
                                                    labelText={formField.city.label}
                                                    name={formField.city.name}
                                                    id={formField.city.name}
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={4}>
                                                <FormControl
                                                    className={"MuiFormControl-fullWidth"}
                                                    style={{
                                                      paddingBottom: "10px",
                                                      margin: "27px 0 0 0",
                                                      position: "relative",
                                                      verticalAlign: "unset"
                                                    }}
                                                >
                                                    <InputLabel htmlFor={formField.state.name}  className={classes.labelComponent + " MuiInputLabel-shrink MuiInputLabel-formControl"}>
                                                        {formField.state.label}
                                                    </InputLabel>
                                                    <Field
                                                        component={Select}
                                                        label={formField.state.label}
                                                        name={formField.state.name}
                                                        id={formField.state.name}
                                                        inputProps={{
                                                            name: formField.state.name,
                                                            id: formField.state.name
                                                        }}
                                                        className={classes.underline}
                                                    >
                                                        ({
                                                        state.map((prop, key) => <MenuItem key={key}
                                                                                           value={prop.short}>{prop.long}</MenuItem>)
                                                    })
                                                    </Field>
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={4}>
                                                <Field
                                                    component={CustomInput}
                                                    labelText={formField.postal_code.label}
                                                    name={formField.postal_code.name}
                                                    id={formField.postal_code.name}
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <Field
                                                    component={CustomInput}
                                                    labelText={formField.about_me.label}
                                                    name={formField.about_me.name}
                                                    id={formField.about_me.name}
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        multiline: true,
                                                        rows: 5
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </CardBody>
                                    <CardFooter>
                                        <Button color="primary" disabled={isSubmitting} type="submit">Update Profile</Button>
                                    </CardFooter>
                                </Card>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                                <Card profile>
                                    <CardAvatar profile>
                                        <a href="#pablo" onClick={e => e.preventDefault()}>
                                            <img src={avatar} alt="..."/>
                                        </a>
                                    </CardAvatar>
                                    <CardBody profile>
                                        <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>
                                        <h4 className={classes.cardTitle}>{fullName}</h4>
                                        <p className={classes.description}>
                                          {aboutMe}
                                        </p>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    </Form>
                )}
            </Formik>
        </div>
    );
}
